module.exports = __webpack_public_path__ + "img/triaFlight.8abc5c0d.svg";